<template>
<!-- <MyDialog v-if="openModal" v-model="openModal" @update:modelValue="openModal = false"
        persistent no-route-dismiss no-backdrop-dismiss no-esc-dismiss
        title="Avertissement !">

    <div class="text-center justify-center q-pt-md">
        <p>
            <q-icon :name="!onLine ? 'warning_amber' : (showBackOnline ? 'hourglass_top' : 'thumb_up')"
                    :color="!onLine ? 'red-8' : (showBackOnline ? 'info':'green-8')" size="40px" />
        </p>
        <p class="text-h6 text-bold">
            <span v-if="!onLine" class="text-red-8">Vous êtes actuellement<br/>hors ligne</span>
            <span v-else>
                <span v-if="showBackOnline" class="text-info">Connexion à internet en cours...</span>
                <span v-else class="text-green-8">Connexion rétablie</span>
            </span>
        </p>
    </div>
</MyDialog> -->

<q-dialog v-if="openModal" v-model="openModal" @update:modelValue="openModal = false"
        persistent no-route-dismiss no-backdrop-dismiss no-esc-dismiss square>

    <div class="text-center justify-center q-pa-md bg-white" style="text-shadow: 1px 1px 0 #ccc">
        <p>
            <q-icon :name="!onLine ? 'warning_amber' : (showBackOnline ? 'hourglass_top' : 'thumb_up')"
                    :color="!onLine ? 'red-8' : (showBackOnline ? 'info':'green-8')" size="40px" />
        </p>
        <p class="text-bold">
            <span v-if="!onLine" class="text-red-8">Vous êtes actuellement<br/>hors ligne</span>
            <span v-else>
                <span v-if="showBackOnline" class="text-info">Connexion à internet en cours...</span>
                <span v-else class="text-green-8">Connexion rétablie</span>
            </span>
        </p>
    </div>
</q-dialog>

</template>

<script>
export default {
    name:'DetectOnline',
    data() {
        return {
            onLine: navigator.onLine,
            showBackOnline: false,
            openModal: false,
        }
    },
    watch: {
        onLine(v) {
            if (v) {
                this.showBackOnline = true
                setTimeout(() => {
                    this.showBackOnline = false

                    _.delay(()=>{
                        this.openModal = false
                    }, 1500)

                }, 1000)
            } else {
                this.openModal = true
            }
        }
    },

    mounted() {
        window.addEventListener('online', this.updateOnlineStatus)
        window.addEventListener('offline', this.updateOnlineStatus)
    },
    beforeDestroy() {
        window.removeEventListener('online', this.updateOnlineStatus)
        window.removeEventListener('offline', this.updateOnlineStatus)
    },

    methods: {

        updateOnlineStatus(e) {
            const { type } = e
            this.onLine = type === 'online'
        }
    },
}
</script>
